import React, { useState } from "react";
// import { Link } from "react-router-dom";
import { useAmplitude } from "react-amplitude-hooks";
import styled from "@emotion/styled";
// import { ButtonLine } from "style/components/pc";
import PopupPortal from "components/Common/Shared/PopupPortal";
import GuidePopup from "components/Travel/PC/GuidePopup";

interface Props {
  stepInfo: string;
  isIntro?: boolean;
}

const Header: React.FC<Props> = ({ stepInfo, isIntro }) => {
  const [isShowPopup, togglePopup] = useState(false);
  const { logEvent } = useAmplitude();
  return (
    <>
      <HeaderWrap className={isIntro ? "invert" : ""}>
        <div className="inner">
          <a
            href={process.env.REACT_APP_BOMAPP_PARTNER_URL}
            onClick={() =>
              logEvent("logo_button", {
                source: stepInfo
              })
            }
          >
            <h1 className="logo">
              <span className="sr-only">마이리얼트립 & 보맵파트너</span>
            </h1>
          </a>
          {/* <ButtonLine
            type="button"
            className="headerButton"
            onClick={() => {
              logEvent("header_button", {
                source: stepInfo
              });
              togglePopup(!isShowPopup);
            }}
          >
            Chubb 해외여행보험 안내
          </ButtonLine> */}
        </div>
        {isShowPopup && (
          <PopupPortal>
            <GuidePopup onOk={() => togglePopup(!isShowPopup)} />
          </PopupPortal>
        )}
      </HeaderWrap>
    </>
  );
};

const HeaderWrap = styled.header`
  z-index: 10;
  position: fixed;
  top: 0;
  width: 100%;
  border-bottom: 1px solid ${(props) => props.theme.colors.divider};
  background-color: #fff;

  .inner {
    display: flex;
    height: 70px;
    padding-left: 30px;
    padding-right: 30px;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    width: 183px;
    height: 22px;
    background: url(${process.env.REACT_APP_S3_URL}/bomapp_30_b2b2c/images/mrt/pc/logo.svg)
      no-repeat;
    background-size: contain;

    img {
      width: 100%;
    }
  }

  .headerButton {
    width: 170px;
    height: 32px;
  }

  &.invert {
    border-bottom: 0;
    background-color: transparent;

    .inner {
      min-width: initial;
    }

    .logo {
      background-image: url(${process.env.REACT_APP_S3_URL}/bomapp_30_b2b2c/images/mrt/pc/logo-white.svg);
    }

    .headerButton {
      border-color: ${(props) => props.theme.colors.white};
      color: ${(props) => props.theme.colors.white};
    }
  }
`;

export default Header;
